import * as z from "zod/v4";

export const getOnboardingProgress = {
  name: "getOnboardingProgress" as const,
  input: z.object({}),
  output: z.object({
    counted: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
  }),
};
